import axios from "axios";
import { useNonPersistAuthStore } from "../AuthStore/AuthStore";
import { getRefreshtoken } from "../Helpers/APIEndpoints/Endpoints";
import { BASE_URL } from "../Helpers/APICalls/Constants";

const navigateToLogin = () => {
    window.location.href = "/login";// ✅ Works inside Axios interceptors
};
const APIwithoutInterceptor = axios.create({
    baseURL: `${BASE_URL}/api`,
    withCredentials: true, // Required for HttpOnly cookies
    headers: {
        "Content-Type": "application/json",
    },
});

const API = axios.create({
    baseURL: `${BASE_URL}/api`,
    withCredentials: true, // Needed for HttpOnly cookies (refresh token)
    headers: {
        "Content-Type": "application/json",
    },
});


// Function to Refresh Access Token
const refreshAccessToken = async () => {
    try {
        // const refreshToken = getRefreshTokenFromCookies();
        const response = await APIwithoutInterceptor.post(
            getRefreshtoken,// No need to pass refreshToken manually
            {
                withCredentials: true, // Ensures cookies (refresh token) are sent automatically
            }
        );

        // Store the new access token in Zustand
        // useAuthStore.setState({
        //     accessToken: response.data.accessToken,
        // });
        useNonPersistAuthStore.getState().setJWTAccessTokenDev(response.data.accessToken);
        return response.data.accessToken;
    } catch (error) {
        console.error("Failed to refresh token:", error);
        navigateToLogin(); // Redirect to login on failure
        throw error;
    }
};


// 🔹 Request Interceptor: Attach Access Token Automatically 
API.interceptors.request.use(
    (config) => { // Get token from Zustand store 
        // let Jwtaccesstoken = "";
        const accessToken = useNonPersistAuthStore.getState().JwtaccesstokenDev;
        if (accessToken) {
            config.headers.Authorization = `Bearer ${accessToken}`;
        }
        return config;
    },
    (error) => Promise.reject(error)
);

// 🔹 Response Interceptor: Handle Token Expiry & Auto Refresh 
API.interceptors.response.use(
    (response) => response, // If successful, just return the response 
    async (error) => {
        // const Jwtrefershtoken = "";
        const originalRequest = error.config;

        if (error.response?.status === 401 && !originalRequest._retry) {
            originalRequest._retry = true; // Prevent infinite loop 

            try {
                const newAccessToken = await refreshAccessToken();
                originalRequest.headers.Authorization = `Bearer ${newAccessToken}`;
                return API(originalRequest); // Retry request with new token 
            } catch (refreshError) {
                console.error("Failed to refresh token:", refreshError);
                navigateToLogin(); // Redirect to login 
            }
        }

        return Promise.reject(error);
    }
);

export { APIwithoutInterceptor, API }; 
